// extracted by mini-css-extract-plugin
export default {"root":"Navigation_root__ZgouD","list":"Navigation_list__p0lq3","link":"Navigation_link__-7c3H","icon":"Navigation_icon__SPaNI","active":"Navigation_active__q4Hvj"};